// extracted by mini-css-extract-plugin
module.exports = {"titleStyles":"TradeHomeEtfs_titleStyles__OO1gQ"};